/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Different_EmailInputs */

const th_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้อีเมลอื่น`)
};

const en_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a different email`)
};

const ja_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のメールアドレスを使う`)
};

const zh_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用其他邮箱`)
};

const es_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar otro correo`)
};

const pt_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar outro e-mail`)
};

const id_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai email lain`)
};

const fr_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser une autre adresse`)
};

const tl_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumamit ng ibang email`)
};

const vi_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng email khác`)
};

const ko_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 이메일 사용`)
};

const de_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere E-Mail verwenden`)
};

const ru_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать другую почту`)
};

const tr_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başka e-posta kullan`)
};

const it_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa un'altra email`)
};

const pl_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Użyj innego e-maila`)
};

const uk_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Використати іншу пошту`)
};

const hi_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दूसरा ईमेल उपयोग करें`)
};

const ar_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدام بريد آخر`)
};

const ms_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guna e-mel lain`)
};

const bn_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য ইমেল ব্যবহার করুন`)
};

const zh_tw2_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用其他電子郵件`)
};

const zh_hk2_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用其他電子郵件`)
};

const ur_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوسرا ای میل استعمال کریں`)
};

const fa_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایمیل دیگری به کار ببرید`)
};

const sw_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumia barua pepe nyingine`)
};

const nl_use_different_email = /** @type {(inputs: Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ander e-mailadres gebruiken`)
};

/**
* | output |
* | --- |
* | "Use a different email" |
*
* @param {Use_Different_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const use_different_email = /** @type {((inputs?: Use_Different_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Different_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_use_different_email(inputs)
	if (locale === "ja") return ja_use_different_email(inputs)
	if (locale === "zh") return zh_use_different_email(inputs)
	if (locale === "es") return es_use_different_email(inputs)
	if (locale === "pt") return pt_use_different_email(inputs)
	if (locale === "id") return id_use_different_email(inputs)
	if (locale === "fr") return fr_use_different_email(inputs)
	if (locale === "tl") return tl_use_different_email(inputs)
	if (locale === "vi") return vi_use_different_email(inputs)
	if (locale === "ko") return ko_use_different_email(inputs)
	if (locale === "de") return de_use_different_email(inputs)
	if (locale === "ru") return ru_use_different_email(inputs)
	if (locale === "tr") return tr_use_different_email(inputs)
	if (locale === "it") return it_use_different_email(inputs)
	if (locale === "pl") return pl_use_different_email(inputs)
	if (locale === "uk") return uk_use_different_email(inputs)
	if (locale === "hi") return hi_use_different_email(inputs)
	if (locale === "ar") return ar_use_different_email(inputs)
	if (locale === "ms") return ms_use_different_email(inputs)
	if (locale === "bn") return bn_use_different_email(inputs)
	if (locale === "zh-TW") return zh_tw2_use_different_email(inputs)
	if (locale === "zh-HK") return zh_hk2_use_different_email(inputs)
	if (locale === "ur") return ur_use_different_email(inputs)
	if (locale === "fa") return fa_use_different_email(inputs)
	if (locale === "sw") return sw_use_different_email(inputs)
	if (locale === "nl") return nl_use_different_email(inputs)
	return en_use_different_email(inputs)
});